import usePermissions from '../hooks/usePermissions'
import { Navigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../redux/messageSlice'

/**
 * Route guard for signed-in pages.
 *
 * Two separate checks, in order:
 *
 * 1. A session must exist (KAN-22). The route tree is chosen from
 *    `commonReducer.is_logged`, which is rehydrated by redux-persist before the
 *    effect that reads local storage has run - so for the first paint after a
 *    reload, a user whose token is gone can still be handed a signed-in route.
 *    The token in local storage is the authority, and a page with no session
 *    goes to sign-in rather than rendering and then failing its API calls.
 * 2. When `permission` is given, the user must hold it.
 *
 * Neither check is a substitute for the server's own: the API refuses these
 * requests regardless. This only keeps the UI from showing a page the user has
 * no business being on.
 */
const CustomProtectedRoute = ({permission, children, isFromTeamsDashboard}) => {

    const [hasPermission] = usePermissions()
    const dispatch = useDispatch()

    if(!window.localStorage.getItem('token')){
        return <Navigate to='/signin' replace />
    }

    if(permission && !hasPermission(permission)){
        dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!"}))
        return isFromTeamsDashboard ? <Navigate to='/dashboard/teams'/> :  <Navigate to='/dashboard'/>
    }

  return children
  
}

export default CustomProtectedRoute
